<div id="id{{ name }}" class="main {{ userClass }}" (keydown.Tab)="onKey()" (click)="inside()">
  <div
    [class.haserror-gotop]="isshow && f[name].touched && f[name]?.invalid"
    [class.gotop]="isshow"
    id="top{{ idName }}"
    (focus)="focusFunction()"
    (click)="focusFunction(); inp.click()"
    (focusout)="focusOutFunction()"
    class="label">
    <label class="txt" [class.lbl]="isshow"> {{ label }} </label>
    <span class="star" [class.error]="f[name].touched && f[name]?.invalid" *ngIf="required === true"> * </span>
  </div>
  <div
    class="inputbox"
    id="inputbox{{ name }}"
    [class.border]="isshow"
    [class.hasborder]="isshow"
    (focus)="focusFunction()"
    (focusout)="focusOutFunction()">
    <input
      #inp
      sepidzAutoFocus
      [style.width.px]="customWidth"
      [id]="idName"
      tabindex="{{ tabOrder }}"
      type="text"
      [(ngModel)]="currentValue"
      [value]="currentValue"
      class="textinput"
      (focus)="focusFunction()"
      (focusout)="focusOutFunction()"
      [class.hasborder]="isshow"
      [class.border]="isshow"
      [(ngClass)]="class"
      required="{{ required }}"
      name="{{ name }}"
      [disabled]="disabled"
      autocomplete="off"
      (input)="onFilter($event.target.value)"
      (click)="openPopover(true)" />
    <span
      *ngIf="showClear()"
      class="ng-clear-wrapper"
      [title]="'ClientApp.Projects.FrameWorkShell.Shared.Controls.LookUp.Delete' | translate"
      (click)="clearValue()">
      <span class="ng-clear" aria-hidden="true">×</span>
    </span>

    <span class="ng-arrow-wrapper" (click)="openPopover()">
      <span class="ng-arrow"></span>
    </span>
  </div>

  <div class="error errorsize unvisible" id="error{{ name }}" [class.visible]="f[name].touched && f[name]?.invalid">
    <span [hidden]="!f[name].errors?.required"> {{ label }} {{ "Errors.Required" | translate }} </span>
  </div>
</div>

<ssg-popover *ngIf="openToggle" (outsideClick)="closeout()" #ngdropdownpanel id="sdsadsds">
  <ng-container>
    <div *ngIf="openToggle && columns && columns.length" (window:resize)="onResize($event)">
      <kendo-grid
        (click)="inside()"
        #lookupGgrid="kendoGrid"
        id="stlookup"
        [data]="!bindable ? gridView : null"
        [kendoGridBinding]="bindable ? gridView?.data : null"
        [loading]="loading"
        [pageSize]="state.take"
        [skip]="state.skip"
        [height]="pageHeight"
        [groupable]="groupable"
        [group]="state.group"
        [reorderable]="true"
        [pageable]="isPaging"
        [sort]="state.sort"
        [sortable]="{ allowUnsort: true, mode: 'multiple' }"
        [selectedKeys]="mySelection"
        (cellClick)="onUserRowSelect($event)"
        [navigable]="true"
        [selectable]="isMulti"
        [rowSelected]="isRowSelected"
        [kendoGridSelectBy]="'Id'"
        (dataStateChange)="dataStateChange($event)"
        (selectedKeysChange)="onSelectedKeysChange($event)"
        (selectionChange)="onGridSelectionChange($event)"
        [filterable]="false"
        kendoGridExpandGroupBy
        [expandedGroupKeys]="expandedGroupKeys"
        [resizable]="true">
        <kendo-grid-checkbox-column *ngIf="isMulti" showSelectAll="true" [width]="60" [columnMenu]="false" minResizableWidth="60">
          <ng-template kendoGridHeaderTemplate>
            <input
              class="k-checkbox"
              id="selectAllCheckboxId"
              kendoGridSelectAllCheckbox
              [state]="selectAllState"
              (selectAllChange)="onSelectAllChange($event)" />
            <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
          </ng-template>
        </kendo-grid-checkbox-column>
        <kendo-grid-column
          *ngFor="let column of columns"
          field="{{ column.name }}"
          title="{{ column.label }}"
          format="{{ column.format }}"
          [width]="column.columnWidth"
          [minResizableWidth]="column.columnWidth * 0.5"
          [hidden]="!column.listVisible"
          filter="text">
          <ng-template *ngIf="column.textType == 'checkbox'" kendoGridCellTemplate let-dataItem>
            <input type="checkbox" [checked]="dataItem[column.name]" disabled />
          </ng-template>
          <ng-template kendoGridGroupHeaderTemplate let-value="value" let-dataItem>
            {{ column.label }} :{{ value }}
            <input
              class="k-checkbox"
              type="checkbox"
              [checked]="getSelctedChange(column.name, value)"
              (click)="gridGroupHeader(column.name, value, $event)" />
          </ng-template>
        </kendo-grid-column>
        <ng-template kendoPagerTemplate>
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="3"></kendo-pager-numeric-buttons>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
        </ng-template>
      </kendo-grid>
      <!-- <div class="row footer border"> -->
      <!-- <div  class="footerbtn"> -->
      <!-- <button type="button"
                  (click)="OkClicked()">
            <i class="icon-save iconfooter"></i> <span>تایید</span>
          </button> -->
      <!-- <ssg-button (click)="OkClicked()" label="تایید"></ssg-button> -->
      <!-- </div> -->
      <!-- <div class="footerbtn"> -->
      <!-- <button type="button"
                  (click)="CancelClicked()">
            <i class="btnicon icon-cancel-circle"></i> <span>انصرف</span>
          </button> -->
      <!-- <ssg-button (click)="CancelClicked()" label="انصراف"></ssg-button> -->
      <!-- </div> -->
    </div>
    <!-- </div> -->
  </ng-container>
</ssg-popover>
